import React, { Component } from 'react';
import { Modal, Button, Col } from 'react-bootstrap';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Auth from '../../shared/Auth';
import { getClientConfiguration, session } from '../../Service/APIService';
import axios from '../../utils/axiosClient';

class ClientList extends Component {
  constructor() {
    super();
    this.state = {
      clients: [],
      selectedClient: '',
      show: true,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = (event) => {
    const userObj = JSON.parse(localStorage.getItem('UserInfo'));
    window.localStorage.setItem('UserInfo', JSON.stringify(userObj));
    this.setState({ selectedClient: event.target.value });
  };

  toggle() {
    this.props.switchAccount();
  }

  async UNSAFE_componentWillMount() {
    const current = this;
    const checkToken = await Auth();
    if (checkToken) {
      axios
        .get('/appsconfig/client')
        .then((response) => {
          if (response.data.statusCode === 200) {
            const clients = response.data.result.map((div) => ({
              value: div.clientId,
              display: div.name,
              logo: div.logoPath,
            }));
            current.setState({
              clients: [{ value: '', display: '-- Select Client --' }].concat(
                clients
              ),
              selectedClient: window.localStorage.getItem('SessionId'),
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  fetchClientConfiguration = async () => {
    const {
      data: { result, statusCode },
    } = await getClientConfiguration();
    if (statusCode === 200 && result) {
      return result;
    }
    return null;
  };

  async save() {
    this.setState({ show: false });
    const el = document.getElementById('cmbClient');
    const sessionId = el.options[el.selectedIndex].value;
    session.setClient(sessionId);

    const configResult = await this.fetchClientConfiguration();
    const { clients } = this.state;
    const { logo } = clients.find((x) => x.value === Number(sessionId));
    const userObj = { ...session.user() };
    userObj.clientname = el.options[el.selectedIndex].text;
    userObj.clientLogo = logo;
    if (configResult) {
      const {
        showRTUHealthTab,
        showAssetTab,
        showSubstationHealthTab,
        showOutageTab,
        showTitle,
        showNetworkTab,
        showGDSData,
        showPQData,
      } = configResult;
      userObj.showAssetTab = !!showAssetTab;
      userObj.showGDSData = !!showGDSData;
      userObj.showRTUHealthTab = !!showRTUHealthTab;
      userObj.showSubstationHealthTab = !!showSubstationHealthTab;
      userObj.showOutageTab = !!showOutageTab;
      userObj.showTitle = !!showTitle;
      userObj.showNetworkTab = !!showNetworkTab;
      userObj.showPQData = !!showPQData;
    }
    session.setUser(userObj);
    toast.success(
      `You are browsing client data for client ${
        el.options[el.selectedIndex].text
      }`,
      {
        position: toast.POSITION.BOTTOM_RIGHT,
      }
    );
    setTimeout(() => {
      window.location.reload();
    }, 3000);
    // this.props.saveInSession(selectedClient);
    // this.props.switchAccount();
  }

  render() {
    return (
      <div>
        <Modal show={this.state.show} onHide={(e) => this.toggle(e)}>
          <Modal.Header closeButton>
            <Modal.Title>Please select Client</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ display: 'flow-root' }}>
            <Col md={2} xs={0}></Col>
            <Col xs={12} md={8}>
              <select
                className="form-control"
                id="cmbClient"
                placeholder=""
                onChange={(event) => this.handleChange(event)}
                value={this.state.selectedClient}
              >
                {this.state.clients.map((c) => (
                  <option key={c.value} value={c.value}>
                    {c.display}
                  </option>
                ))}
              </select>
            </Col>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={(e) => this.save(e)}
              bsStyle="success"
              bsSize="small"
            >
              Ok
            </Button>

            <Button
              onClick={(e) => this.toggle(e)}
              bsStyle="danger"
              bsSize="small"
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
export default ClientList;
